// import menuImage from '../assets/image/menu-image.webp'

export const menuItems = [
  {
    name: "#desarrollo",
    label: "Desarrollo",
  },
  {
    name: "#amenidades",
    label: "Amenidades",
  },
  {
    name: "#departamentos",
    label: "Departamentos",
  },
  {
    name: "#oficinas",
    label: "Oficinas",
  },
  {
    name: "#ubicacion",
    label: "Ubicación",
  },
  {
    name: "#rentas",
    label: "Rentas",
  },
  {
    name: "#contacto",
    label: "Contacto",
  },
]
export default menuItems
